import { Marker, MarkerClusterer } from '@googlemaps/markerclusterer'
import { useEffect, useMemo } from 'react'

import Colors from '#/styles/Colors'

type CustomMarker = Marker & {
  status_for_map?: string
}

// Clusterer hook extraído
function useClusterer(map: google.maps.Map | null, clusterMarkers: Record<string, any>) {
  const clusterer = useMemo(() => {
    if (!map) return null
    return new MarkerClusterer({
      map,
      renderer: {
        render: ({ count, markers, position }) => {
          const color = getColorForStatus(markers as CustomMarker[])

          const svg = window.btoa(`
                <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                  <circle cx="120" cy="120" opacity=".9" r="70" />
                  <circle cx="120" cy="120" opacity=".6" r="90" />
                  <circle cx="120" cy="120" opacity=".3" r="110" />
                  <circle cx="120" cy="120" opacity=".1" r="130" />
                </svg>
              `)

          const div = document.createElement('div')
          div.innerHTML = `
                <div style="position: relative;">
                  <img src="data:image/svg+xml;base64,${svg}" width="45" height="45" />
                  <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -55%);
                    color: white;
                    font-size: 12px;
                  ">${count}</div>
                </div>
              `

          return new google.maps.marker.AdvancedMarkerElement({
            content: div,
            position,
            zIndex: 1000 + count,
          })
        },
      },
    })
  }, [map])

  useEffect(() => {
    if (!clusterer) return
    clusterer.clearMarkers()
    clusterer.addMarkers(Object.values(clusterMarkers))

    return () => {
      clusterer.clearMarkers()
    }
  }, [clusterer, clusterMarkers])

  return clusterer
}
export { useClusterer }

/**
 * Encontra cor do cluster com base no status dos marcadores
 * A prioridade é: offline > waiting > operational
 * Status inativo não afeta a cor do cluster
 */

function getColorForStatus(markers: CustomMarker[]) {
  let color = Colors.map.markers.ccom['operational']

  const warningMarkers = markers.some(marker => {
    return marker?.status_for_map === 'waiting'
  })

  if (warningMarkers) {
    color = Colors.map.markers.ccom['waiting']
  }

  const offlineMarkers = markers.some(marker => {
    return marker?.status_for_map === 'offline'
  })

  if (offlineMarkers) {
    color = Colors.map.markers.ccom['offline']
  }
  return color
}
